import { useEffect, useState } from "react";
import { axiosInstance } from "../config";
import { requestErrorDetails } from './requestError.mjs';
let catalogue = null, error = "", pending;
let selection = "openai:gpt-5.2";
try { const saved = localStorage.getItem("translation.preferredModel"); if (saved && saved.length <= 160) selection = saved; } catch {}
const listeners = new Set();
const emit = () => listeners.forEach(listener => listener({ catalogue, error, selection }));
async function load(refresh = false) {
  if (pending) return pending;
  pending = (async () => {
    try {
      const response = refresh ? await axiosInstance.post("/api/translations/models/refresh", {}, { timeout: 15000 }) : await axiosInstance.get("/api/translations/models", { timeout: 15000 });
      catalogue = response.data;
      if (catalogue.localLibreOnly) selection = catalogue.defaultSelection;
      error = "";
    } catch (e) { error = requestErrorDetails(e, { readOnly: true, fallback: 'Translation models could not be loaded.' }).message; }
    finally { pending = null; emit(); }
  })();
  return pending;
}
export default function useTranslationModels() {
  const [state, setState] = useState({ catalogue, error, selection });
  useEffect(() => {
    listeners.add(setState);
    if (!catalogue) load(); else setState({ catalogue, error, selection });
    return () => { listeners.delete(setState); };
  }, []);
  return { ...state, ready: Boolean(state.catalogue?.models?.find(model => model.id === state.selection)?.enabled), setSelection: value => { selection = value; try { localStorage.setItem("translation.preferredModel", value); } catch {} emit(); }, refresh: () => load(true) };
}
